import React, { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Dumbbell, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get("token") || "";
    const [pwd, setPwd] = useState("");
    const [pwd2, setPwd2] = useState("");
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        if (!token) toast.error("Reset link is missing the token");
    }, [token]);

    const submit = async (e) => {
        e.preventDefault();
        if (pwd.length < 6) { toast.error("Password must be at least 6 characters"); return; }
        if (pwd !== pwd2) { toast.error("Passwords don't match"); return; }
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, password: pwd });
            toast.success("Password updated — sign in with your new password");
            navigate("/login");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Could not reset password");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-4 py-12">
            <div className="w-full max-w-md">
                <Link to="/login" data-testid="rp-back" className="mb-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-white/60 hover:text-white">
                    <ArrowLeft className="h-3.5 w-3.5" /> Back to sign in
                </Link>
                <div className="flex items-center gap-2">
                    <Dumbbell className="h-6 w-6 text-accent-red" />
                    <span className="font-display text-2xl font-black uppercase">Hyper<span className="text-accent-red">gains</span></span>
                </div>
                <h1 className="mt-8 font-display text-4xl font-black uppercase">New password</h1>
                <p className="mt-2 text-sm text-white/65">
                    Pick something you'll remember. 6 characters minimum.
                </p>
                <form onSubmit={submit} className="mt-8 space-y-3" data-testid="rp-form">
                    <div>
                        <label className="label-eyebrow text-white/60">New password</label>
                        <input type="password" required value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="rp-password" className="w-full rounded-sm border border-white/20 bg-black/30 px-3 py-3 text-sm focus:border-accent-red focus:outline-none" />
                    </div>
                    <div>
                        <label className="label-eyebrow text-white/60">Confirm password</label>
                        <input type="password" required value={pwd2} onChange={(e) => setPwd2(e.target.value)} data-testid="rp-password-confirm" className="w-full rounded-sm border border-white/20 bg-black/30 px-3 py-3 text-sm focus:border-accent-red focus:outline-none" />
                    </div>
                    <button type="submit" disabled={busy || !token} data-testid="rp-submit" className="w-full rounded-sm bg-accent-red px-4 py-3 text-sm font-bold uppercase tracking-wider text-white hover:bg-[color:var(--accent-hover)] disabled:opacity-60">
                        {busy ? "Updating…" : "Reset password"}
                    </button>
                </form>
            </div>
        </div>
    );
}
